import React from 'react';

import i18n from 'i18n/helper';
import SvgIcon from '../SvgIcon';
/**
 * Extracted from SlimUploader.jsx
 * to be used in FeedbackForm. The motive is that now we can have multiple image upload BUT ONLY on general feedback form.
 * ref. https://github.com/sdesregistry/IH-Engage/issues/2414
 * Other places where this component is used (via <SlimUploader />), will not be affected.
 *
 * So, we have two interfaces for uploading images:
 * 1. New interface - used in FeedbackForm, where we can upload multiple images.
 * New interface does not display uploaded images in the SlimUploader, but instead uses this component directly to display uploaded images.
 * The `removeImage` function is optional and is used to remove an image in case of multiple image handling.
 * 2. Legacy interface - used in SlimUploader, where we can upload a single image.
 * The legacy interface receives an image object with id and filename.
 * Removing image is done by passing an empty object to the `setImage` function.
 */
export function UploadedImages(props) {
  const { image, modifierClass, imageFormat, setImage, tip, removeImage } = props;

  // If removing single we use setImage to set an empty object
  // If removing multiple images we use explicit removeImage passed from parent component
  const _removeImage = removeImage || setImage;

  const getFilenameLong = () =>
    image?.filename?.length > 20 ? `${image.filename.substring(0, 10)}...` : image.filename || 'Untitled';

  return (
    <>
      <div className={`c-upload ${modifierClass || ''} ${imageFormat.previewModifier || ''}`}>
        <div className='c-upload__preview'>
          {/* <img src={getImageUrl(imageUrl || uploadedImageId, imageFormat.imageType)} alt='' /> */}
          {/* <img src={getImageUrl(imageUrl || uploadedImageId, { name: '' })} alt='' className='c-upload__image' /> */}
          <img
            src={`https://s3.us-west-2.amazonaws.com/gmv-done.image.givemyview.com/user-content/image/${image.id}`}
            alt=''
            className='c-upload__image'
          />
          <span className='c-upload__image-label'>{getFilenameLong()}</span>
          <button className='c-upload__remove' type='button' onClick={() => _removeImage({})}>
            <SvgIcon icon='times' />
            <span className='u-screen-reader-text'>{i18n.t('questions.feedbackForm.removeImage')}</span>
          </button>
        </div>
      </div>
      {tip && <p className='c-field__description'>{tip}</p>}
    </>
  );
}
